import request from '../request'

/**
 * iOS 快捷指令收件箱接口。
 * 场景：在社交平台看到想留存的内容，复制后由快捷指令投递到这里，
 * 上班时间再回来逐条验证。
 */

/**
 * 获取收件列表（按收件时间倒序，最新在最前）。
 * @param {Object} [params] 查询参数。
 * @param {number} [params.page=1] 页码，从 1 开始。
 * @param {number} [params.pageSize=50] 每页条数，后端上限 200。
 * @returns {Promise<{list: Array, total: number, page: number, pageSize: number}>}
 */
export function fetchInboxList(params = {}) {
  return request({
    url: '/api/inbox',
    method: 'GET',
    params,
  })
}

/**
 * 手动新增一条收件内容。
 * 快捷指令走的是同一个接口，此方法用于在页面上手动补录。
 * @param {string} content 收件正文。
 * @returns {Promise<Object>} 新增后的收件记录
 */
export function createInboxItem(content) {
  return request({
    url: '/api/inbox',
    method: 'POST',
    data: { content },
  })
}

/**
 * 更新单条收件的自定义标题。
 * @param {number|string} id 收件 ID。
 * @param {string} title 标题，传空串表示清空。
 * @returns {Promise<Object>} 更新后的收件记录
 */
export function updateInboxTitle(id, title) {
  return request({
    url: `/api/inbox/${id}`,
    method: 'PUT',
    data: { title },
  })
}

/**
 * 更新单条收件的正文内容。
 * @param {number|string} id 收件 ID。
 * @param {string} content 新的正文，不能为空。
 * @returns {Promise<Object>} 更新后的收件记录
 */
export function updateInboxContent(id, content) {
  return request({
    url: `/api/inbox/${id}`,
    method: 'PUT',
    data: { content },
  })
}

/**
 * 删除单条收件内容。
 * @param {number|string} id 收件 ID。
 * @returns {Promise<Object>} { id }
 */
export function deleteInboxItem(id) {
  return request({
    url: `/api/inbox/${id}`,
    method: 'DELETE',
  })
}

/**
 * 清空全部收件内容。
 * @returns {Promise<Object>} { deleted }
 */
export function clearInbox() {
  return request({
    url: '/api/inbox',
    method: 'DELETE',
  })
}
